<template lang="pug">
  div#app(v-show='$auth.ready()')
    div(v-if='$auth.check()')
      modal-feedback
      the-header
      LoadingScreen(:visible="isLoading")
      the-notifications
      modal-search-projects
      transition(name="slide")
        chat(v-if="isChatVisible && $auth.check()" @visible="setChatVisible")
      .app(@click="closeNotifications")
        the-menu
        .background--transition
          #rfi(v-if="$auth.check() && !['Gallery', 'rfis'].includes(this.$route.name) && !$auth.check('Customer')" @click="setChatVisible(!isChatVisible)")
            vm-tooltip(text="New RFI" delay=".02s" position="left")
              .rfi-button
                vm-icon(icon="file-text-outline" size="1.5rem")
          transition(name="enter" mode="out-in")
            router-view(v-if='$auth.ready()')
    //- base-auth(v-if='!$auth.check()')
    router-view(v-else)
    vue-progress-bar
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    BaseAuth: () => import('@/components/BaseAuth.vue'),
    TheHeader: () => import('@/components/TheHeader.vue'),
    TheMenu: () => import('@/components/TheMenu.vue'),
    ModalFeedback: () => import('@/components/aditionals/ModalFeedback.vue'),
    ModalSearchProjects: () => import('@/components/aditionals/ModalSearchProjects.vue'),
    TheNotifications: () => import('@/components/TheNotifications.vue'),
    Chat: () => import('@/components/rfis/Chat.vue'),
    LoadingScreen: () => import('@/components/aditionals/LoadingScreen.vue')
  },
  data: () => ({
    isChatVisible: false,
    rfis_store_permission: true
  }),
  mounted () {
    this.$auth.ready(async () => {
      if (this.$auth.check()) {
        await this.loadData()
      }
    })
    this.$Progress.finish()
  },
  created () {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        this.$Progress.parseMeta(meta)
      }
      to.meta.color !== undefined && document.querySelector('meta[name=theme-color]').setAttribute('content', to.meta.color)
      this.$Progress.start()
      next()
    })
    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
    })
    this.checkPermission()
  },
  computed: {
    ...mapGetters([
      'alertMessage',
      'acceptAlert',
      'isLoading'
    ])
  },
  watch: {
    alertMessage: function (alertMessage) {
      this.$vm.dialog({
        color: alertMessage.color,
        title: this.$t(alertMessage.title),
        text: this.$t(alertMessage.text)
      })
    },
    acceptAlert: function (acceptAlert) {
      if (acceptAlert) {
        this.$vm.notify({
          color: acceptAlert.color,
          title: this.$t(acceptAlert.title),
          text: this.$t(acceptAlert.text),
          icon: acceptAlert.icon
        })
      }
    }
  },
  methods: {
    ...mapActions([
      'loadData',
      'setAcceptAlert',
      'closeNotifications'
    ]),
    checkPermission (permission) {
      this.rfis_store_permission = this.$auth.user().view_permissions && this.$auth.user().view_permissions.findIndex(e => e.name === 'rfis.store') > -1
    },
    setChatVisible (boolean) {
      this.isChatVisible = boolean
    },
    changeLocale (locale) {
      this.$i18n.set(locale)
    }
  }
}
</script>

<style lang="scss">
/* @import '~bootstrap/scss/bootstrap'; */
@import './style/eva/scss/eva-icons';
@import url('https://fonts.googleapis.com/css?family=Poppins:400,700&display=swap');
body {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  background-color: #fff;
  line-height: 1.5;
}
html {
  /* Load system fonts */
  font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Roboto', 'Oxygen', 'Segoe UI', 'Fire Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  /* Make type rendering look crisper */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Disable auto-enlargement of small text in Safari */
  text-size-adjust: 100%;
  /* Enable kerning and optional ligatures */
  text-rendering: optimizeLegibility;
  line-height: 1.5;
}
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  text-transform: none;
  text-decoration: none;
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    display: block
  }
  ::-webkit-scrollbar-thumb {
    background: #e4eaf5;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-thumb {
    &:hover {
      background: rgb(196, 201, 211)
    }
  }
}
a {
  color:  rgba(var(--primary),1);
}

input, button, select, optgroup, textarea {
    margin: 0;
    font-family: inherit;
    line-height: inherit;
}
.justify-content-between {
  -webkit-box-pack: justify !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
}
.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.form-group {
  margin-bottom: 1rem;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.container-fluid {
    width: 100%;
    padding-right: 40px;
    padding-left: 40px;
    margin-right: auto;
    margin-left: auto;
    min-height: 100%;
    @media only screen and (max-width: 600px) {
      padding-right: 5px;
      padding-left: 5px;
    }
}
#app {
  .app {
    display: flex;
    height: 100vh;
    background: rgba(var(--primary),1);
  }
  .background--transition {
    background-color: #fafafa;
    padding-top: 70px;
    min-height: 100%;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    width: 100%;
    overflow: auto;
  }
  .crud {
    .footer {
      z-index: 1000;
      background: rgba(var(--primary),1);
      width: 100%;
      padding: 5px;
      /* margin-top: 40px; */
      justify-content: flex-end;
      display: flex;
      button {
        margin: 5px;
      }
    }
    .heading {
      margin-bottom: 15px;
      .vm-col {
        &:first-child {
          div {
            &:last-child {
              padding-left: 20px
            }
          }
        }
      }
      .vm-button {
        margin: 0 3px;
      }
    }
    .card {
      margin-bottom: 40px;
      background: white;
      padding: 5px;
      border-radius: 5px;
      box-shadow: 5px 5px 25px 0 rgba(46,61,73,.11);
      .form {
        .con-select {
          width: 100%;
        }
      }
      .vm-con-table {
        width: 100%;
      }
    }
    .float {
      position:fixed;
      bottom:40px;
      right:40px;
      z-index: 1000;
    }
    .total-records {
      position: absolute;
      margin-top: -28px;
      right: 55px;
      color: rgba(var(--primary),1);
    }
  }
  .enter-enter-active, .enter-leave-active {
    transition: all .2s ease;
  }
  .enter-enter, .enter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  @media only screen and (max-width: 768px) {
    /* For mobile phones: */
    .form-group {
      margin-bottom: 2rem;
    }
    .vm-button {
      padding: 15px;
    }
  }
}
#rfi {
  z-index: 999;
  position: fixed;
  bottom: 30px;
  right: 30px;
  height: 60px;
  width: 60px;
  color: white;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  .rfi-button {
    height: 60px;
    width: 60px;
    border-radius: 50%;
    transition: all 0.1s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: rgba(var(--primary), 1);
    &:hover {
      -webkit-box-shadow: 0px 5px 12px 3px rgba(0,0,0,0.25);
      -moz-box-shadow: 0px 5px 12px 3px rgba(0,0,0,0.25);
      box-shadow: 0px 5px 12px 3px rgba(0,0,0,0.25);
      transform: scale(1.1);
    }
  }
}

@media only screen and (min-width: 1930px) {
  h2 {
    font-size: 1.2vw;
  }
  span {
    font-size: 0.75vw;
  }
  .vm-table-text {
    font-size: 0.7vw;
  }
  .background--transition {
    padding-top: 3.2vw !important;
  }
}
.slide-enter-active {
  transition: all .3s ease-in-out;
}
.slide-leave-active {
  transition: all .3s ease-in-out;
}
.slide-enter, .slide-leave-to {
  transform: translateY(90vh);
}
.vm-viewer-controlls {
  z-index: 11002 !important;
}
.vm-viewer-image {
  z-index: 11002 !important;
  pointer-events: none;
}
.vm-viewer-image > img {
  z-index: 11002 !important;
}
.vm-viewer-dark {
  z-index: 0 !important;
}
</style>
